import * as zod from 'zod';

// Add supported teleop modes here
// Also update TELEOP_MODE_LABELS in libs/remote-control/step/teleop.ts
export const TeleopModeEnum = zod.enum(['arHeadset']);

export type TeleopMode = zod.infer<typeof TeleopModeEnum>;

export default zod.object({
  mode: TeleopModeEnum.default('arHeadset'),
  timeoutSeconds: zod.number().int().positive().default(300),
  tags: zod.array(zod.string().max(30)).default([]),
});
